import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const ResidualInformationPDF = ({ isDealerDisclosure }) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}} wrap={false}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Residual Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>
                        MSRP
                    </Text>
                    <Text>{pdfData.msrp.toDollarFormat()}</Text>
                </View>

                {
                    pdfData.max_advance && isDealerDisclosure &&
                    <View style={baseStyles.flexBetween}>
                        <Text>
                            Max Advance
                        </Text>
                        <Text>{pdfData.max_advance.toDollarFormat()}</Text>
                    </View>
                }


                {/*<View style={baseStyles.flexBetween}>*/}
                {/*    <Text>MRM</Text>*/}
                {/*    <Text>{pdfData.mrm ? pdfData.mrm.toDollarFormat() : 'N/A'}</Text>*/}
                {/*</View>*/}

                <View style={baseStyles.flexBetween}>
                    <Text>Residual Percentage</Text>
                    <Text>{pdfData.residual_percentage}%</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Annual Mileage</Text>
                    <Text>{pdfData.annual_mileage}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Residual Amount</Text>
                    <Text>{pdfData.total_residual.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}